<template>
  <section class="section">
    <van-row class="section-head">
      <van-col span="22">
        <h2 class="title">{{ t('appStore.privacyTitle') }}</h2>
      </van-col>
      <van-col span="2">
        <van-icon name="arrow" size="16" color="#9ca3af" />
      </van-col>
    </van-row>

    <p class="intro">
      {{ t('appStore.privacyIntroPrefix') }}
      <span class="link">{{ t('appStore.developerName') }}</span>
      {{ t('appStore.privacyIntroMiddle') }}
      <span class="link">{{ t('appStore.privacyPolicyLink') }}</span>
      {{ t('appStore.privacyIntroSuffix') }}
    </p>

    <div v-for="card in appData.privacy.cards" :key="card.id" class="privacy-card">
      <div class="privacy-card-head">
        <CardIcon :kind="card.icon" />
        <h3 class="card-title">{{ t(privacyCardKey(card.i18nKey, 'Title')) }}</h3>
        <p class="card-desc">{{ t(privacyCardKey(card.i18nKey, 'Description')) }}</p>
      </div>
      <van-row class="items-grid">
        <van-col v-for="item in card.items" :key="item.i18nKey" span="12">
          <div class="item-row">
            <van-icon :name="item.icon" size="16" color="#374151" />
            <span>{{ t(privacyItemKey(item.i18nKey)) }}</span>
          </div>
        </van-col>
      </van-row>
    </div>

    <p class="disclaimer">
      {{ t('appStore.privacyDisclaimer') }}
      <span class="link">{{ t('appStore.learnMore') }}</span>
    </p>
  </section>
</template>

<script lang="ts" setup>
import { useI18n } from 'vue-i18n';
import { appData } from '@/lib/app-data';
import { privacyCardKey, privacyItemKey } from '../i18n-keys';
import CardIcon from './CardIcon.vue';

const { t } = useI18n();
</script>

<style scoped>
.section {
  padding: 24px 16px 0;
}

.section-head {
  align-items: center;
  margin-bottom: 12px;
}

.title {
  margin: 0;
  font-size: 22px;
  font-weight: 700;
  color: #111827;
}

.intro,
.disclaimer {
  margin: 0;
  font-size: 13px;
  line-height: 1.45;
  color: #4b5563;
}

.link {
  color: #007AFF;
}

.privacy-card {
  margin-top: 16px;
  padding: 16px;
  border: 1px solid #e5e7eb;
  border-radius: 16px;
  background: #f9fafb;
}

.privacy-card-head {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.card-title {
  margin: 8px 0 0;
  font-size: 15px;
  font-weight: 600;
  color: #111827;
}

.card-desc {
  margin: 4px 0 0;
  font-size: 12px;
  line-height: 1.35;
  color: #6b7280;
}

.items-grid {
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid #e5e7eb;
}

.item-row {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 10px;
  font-size: 13px;
  color: #1f2937;
}

.disclaimer {
  margin-top: 12px;
}
</style>
